import * as React from 'react';
import { toUrlFormat } from '../../../../../utils/treeVisitors';
import { APPEARANCES, Heading } from '../../../PageElements/Heading';
import { IntersectionSubscriber } from '../../../SectionIntersectionDetection/IntersectionSubscriber';
import style from './TopLevelCategoryIndexPage.scss';

export const TopLevelCategoryIndexPage = ({ categoryName, prefix }) => (
  <div
    className={style.topLevelCategoryIndexPageInfo}
    data-hook={`top-level-category-index-page-${toUrlFormat(categoryName)}`}
  >
    <IntersectionSubscriber
      className={style.intersectionSubscriber}
      tagName="div"
      id={prefix}
    />

    <Heading
      appearance={APPEARANCES.H1}
      isCategoryTitle={true}
      className={style.guidesSectionTitle}
    >
      {categoryName}
    </Heading>
  </div>
);
